"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.opStatusColor = exports.opStatusLabel = exports.OpStatus = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
// eslint-disable-next-line no-shadow
var OpStatus;
(function (OpStatus) {
    OpStatus["NOT_DUE"] = "NOT_DUE";
    OpStatus["DUE"] = "DUE";
    OpStatus["OVERDUE_NOTSTARTED"] = "OVERDUE_NOTSTARTED";
    OpStatus["STARTED"] = "STARTED";
    OpStatus["OVERDUE_STARTED"] = "OVERDUE_STARTED";
    OpStatus["PENDING"] = "PENDING";
    OpStatus["COMPLETED"] = "COMPLETED";
    OpStatus["COMPLETED_LATE"] = "COMPLETED_LATE";
    OpStatus["MISSED"] = "MISSED";
})(OpStatus = exports.OpStatus || (exports.OpStatus = {}));
exports.default = OpStatus;
function opStatusLabel(status) {
    switch (status) {
        case OpStatus.NOT_DUE:
            return lib_i18n_1.default.t('opstatus_not_due');
        case OpStatus.DUE:
            return lib_i18n_1.default.t('opstatus_due');
        case OpStatus.OVERDUE_NOTSTARTED:
            return lib_i18n_1.default.t('opstatus_overdue_notstarted');
        case OpStatus.STARTED:
            return lib_i18n_1.default.t('opstatus_started');
        case OpStatus.OVERDUE_STARTED:
            return lib_i18n_1.default.t('opstatus_overdue_started');
        case OpStatus.PENDING:
            return lib_i18n_1.default.t('opstatus_pending');
        case OpStatus.COMPLETED:
            return lib_i18n_1.default.t('opstatus_completed');
        case OpStatus.COMPLETED_LATE:
            return lib_i18n_1.default.t('opstatus_completed_late');
        case OpStatus.MISSED:
            return lib_i18n_1.default.t('opstatus_missed');
    }
}
exports.opStatusLabel = opStatusLabel;
function opStatusColor(status) {
    switch (status) {
        case OpStatus.NOT_DUE:
            return lib_palette_1.default.Platinum;
        case OpStatus.DUE:
            return lib_palette_1.default.MellowYellow; // MellowYellow
        case OpStatus.OVERDUE_NOTSTARTED:
            return lib_palette_1.default.MellowYellow; // OJ
        case OpStatus.STARTED:
            return lib_palette_1.default.OJ; // GoodOldBlue
        case OpStatus.OVERDUE_STARTED:
            return lib_palette_1.default.OJ; // MustardYellow
        case OpStatus.PENDING:
            return lib_palette_1.default.LightPurple;
        case OpStatus.COMPLETED:
            return lib_palette_1.default.Greeny;
        case OpStatus.COMPLETED_LATE:
            return lib_palette_1.default.Greeny; // GoodGreen
        case OpStatus.MISSED:
            return lib_palette_1.default.BadRed; // TimelineRed
    }
}
exports.opStatusColor = opStatusColor;
